/**
 * The share intents' names, as they appear in a link's `?intent=` (utils/shareIntents/index.js
 * registry). Kept apart from the intents themselves so code that only reads a link, such as the
 * assistant's link bridge (Assistant/domain/linkIntent.js), can name one without loading the player.
 * No imports, so `npm run test:unit` (node --test) can load it directly.
 */
export const SHARE_INTENT_TYPE = Object.freeze({
  TASK_BOARD: 'task-board',
});
